export default "__VITE_ASSET__CGir9pAv__"